import React, { useMemo,useState, useEffect } from 'react';
import './index.scss';
import { Link } from 'react-router-dom';
// import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { FormattedMessage } from 'react-intl';


import {
  one, two, three, four, five, 
  // cone, ctwo, cthree, cfour, 
  // location, bath, bed, square,img1, img5,img6, img7, img8, img9,img12img14, img15, img16, img17, img18,
   img2, img3, img4, img10, img11, img13,  img19,
  comporta, azeitao, sintra, sesimbra, estoril, troia,
  blueprop
} from '../../assets/cloudinaryUrls.js';

function Home() {

  const imageArray  = useMemo(() => [one,
     two, three, four, five], []);

  let [count, setCount] = useState(0);
  const [image, setImage] = useState(imageArray[0]);
  

  useEffect(() => {
    setImage(imageArray[count]);
  }, [count, imageArray]);

  // useEffect(() => {
  //   setInterval(() => {
  //     setCount(count + 1);
  //   }, 10000);
  // }, []);
  useEffect(() => {
    const intervalId = setInterval(() => {
      // Use a functional update to ensure the latest count value
      setCount((prevCount) => (prevCount + 1)% imageArray.length);
    }, 8000);

    // Clear the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, [imageArray.length]);

  


  // const data = [
  //   {img: cone, name: "Property Name", price:"XXX XXX €", location: "location, Portugal", bed: "x TX", bath: "x X", size: "XXXm2"},
  //   {img: ctwo, name: "Property Name", price:"XXX XXX €", location: "location, Portugal", bed: "x TX", bath: "x X", size: "XXXm2"},
  //   {img: cthree, name: "Property Name", price:"XXX XXX €", location: "location, Portugal", bed: "x TX", bath: "x X", size: "XXXm2"},
  //   {img: cfour, name: "Property Name", price:"XXX XXX €", location: "location, Portugal", bed: "x TX", bath: "x X", size: "XXXm2"}
  // ]

  const dataimg =  [
    { id:1, img: img4}, {id:2, img: img2}, {id:3, img: img3}
   
  ]
  const datacities = [
    { id:1, img: azeitao, city: 'Azeitao', prop: "home.city.where_vineyards_meet_tradition" },
    { id:2, img: comporta, city: 'Comporta', prop:   "home.city.discover_beauty_of_nature_meets_luxury"},
    { id:3, img: sintra, city: 'Sintra', prop:  "home.city.explore_enchanting_fairy_tale_town" },
    { id:4, img: sesimbra, city: 'Sesimbra', prop:   "home.city.where_sea_meets_mountains" },
    { id:5, img: estoril, city: 'Estoril', prop: "home.city.a_coastal_paradise" },
    { id:6, img: troia, city: 'Troia', prop:   "home.city.an_island_of_tranquility" },
  ];
  

  return (
    <div>
      <div className='img-wrapper anim height'>
        <div className='img-text text-flex'>
          
          <h4><FormattedMessage id="home.title"/></h4>
          <h6><FormattedMessage id="home.subtitle" /></h6>
          <Link to="/about" className='home-button anim-btn prop-btn'>
            <FormattedMessage id="home.button" />
          </Link>
        </div>
        <img src={image} alt='na' className='home-img anim' />
      </div>
      <div className='text-block text-flex div-prop'>
        <h6><i><FormattedMessage id="home.subtitle2" /></i></h6>
        <h4><FormattedMessage id="home.header" /></h4>
        <div className='line'></div>
        <p><FormattedMessage id="home.quote" /></p>
      </div>

      <div className='new-this-month div-prop flex-clmn'>
        <div className='text-line flex-row'>
          <Link to="#" className='text-btn'><p><FormattedMessage id="home.beachfront" /></p></Link>
          <Link to="#" className='text-btn'><p><FormattedMessage id="home.mountainView" /></p></Link>
          <Link to="#" className='text-btn'><h4><FormattedMessage id="home.casascampos" /></h4></Link>
          <Link to="#" className='text-btn'><p><FormattedMessage id="home.newThisMonth" /></p></Link>
          <Link to="#" className='text-btn'><p><FormattedMessage id="home.downtown" /></p></Link>
        </div>
        <div className='imgs-line flex-row'>
          {dataimg.map((newmonth) => (
            <img src={newmonth.img} alt='na' className='img-new' key={newmonth.id} />
          ))}
        </div>
        <Link to="/about" className='month-button anim-btn prop-btn'>
          <FormattedMessage id="home.contactNow" />
        </Link>
      </div>
      <div className='text-block text-flex div-prop'>
        <h5><FormattedMessage id="home.propertySelection" /></h5>
        <p><FormattedMessage id="home.propertySelectionDescription" /></p>
      </div>
      <div className='blue-cont'>
        <img src={img19} alt='' className="page-img"/>
        <div className='content-blue flex-clmn'>
          <div className='inline-blocks flex-row'>
            <Link to="#" className='block'>
              <img src={img11} alt='na' className="small-img"/>
              <div className="column-text">
                <p><FormattedMessage id="home.goldenVisa" /></p>
                <p><FormattedMessage id="home.goldenVisaDescription" /></p>
              </div>
            </Link>
            <Link to="#" className='block'>
              <img src={img10} alt='na' className="small-img"/>
              <div className="column-text">
                <p><FormattedMessage id="home.findDreamProperty" /></p>
                <p><FormattedMessage id="home.findDreamPropertyDescription" /></p>
              </div>
            </Link>
            <Link to="#" className='block'>
              <img src={img13} alt='na' className="small-img"/>
              <div className="column-text">
                <p><FormattedMessage id="home.propertyOwner" /></p>
                <p><FormattedMessage id="home.propertyOwnerDescription" /></p>
              </div>
            </Link>
          </div>
        </div>
      </div>
      <div className='pop-loc div-prop flex-clmn'>
        <h4><FormattedMessage id="home.popularNearLisbon" /></h4>
        <div className='img-tab'>
          {datacities.map((cities) => (
            <div className='wrapper' key={cities.id}>
              <div className='text-prop text-flex anim-btn'>
                <h5>{cities.city}</h5>
                <div className='line-light anim-btn'></div>
                <p><i><FormattedMessage id={cities.prop}/></i></p>
              </div>
              <img src={cities.img} alt='na' className='img-loc' />
            </div>
          ))}
        </div>
      </div>
      <div className='last-block'>
        <div className='grey-block flex-clmn'>
          <h5><FormattedMessage id="home.joinSelection" /></h5>
          <div className='line'></div>
          <p><FormattedMessage id="home.listYourHouse" /></p>
          <Link to="/about" className='month-button anim-btn prop-btn'>
            <FormattedMessage id="home.submitYourHouse" />
          </Link>
          <img src={blueprop} alt='na' className='img-center' />
        </div>
      </div>
    </div>
  );
}

export default Home

 // const datagroup = [
  //   beachfront, mountain, newmonth, downtown
  // ]

  // const responsive = {
  //   superLargeDesktop: {
  //     // the naming can be any, depends on you.
  //     breakpoint: { max: 4000, min: 3000 },
  //     items: 4
  //   },
  //   biggerdesktop: {
  //     breakpoint: { max: 3000, min: 1800 },
  //     items: 2,
  //     partialVisibilityGutter: 150
  //   },
  //   desktop: {
  //     breakpoint: { max: 1800, min: 1024 },
  //     items: 2
  //   },
  //   tablet: {
  //     breakpoint: { max: 1024, min: 464 },
  //     items: 1,
  //     partialVisibilityGutter: 250
  //   },
  //   mobile: {
  //     breakpoint: { max: 464, min: 0 },
  //     items: 1
  
  //   }
  // };

      /* <div className='carousel'>
        <Carousel 
          swipeable={true}
          draggable={true}
          responsive={responsive}
          // ssr={true} // means to render carousel on server-side.
          infinite={true} 
          partialVisible={true}
          arrows={true} renderButtonGroupOutside={true}  
          
        >
          {data.map((carousel) => (
          <div className='card'>
            <img src={carousel.img} alt='na' className='card-img'/>
            <div className='card-text'>
              <div className='card-name-price'>
                <p>{carousel.name}</p>
                <p className='bold'>{carousel.price}</p>
              </div>
              <div className='card-location'>
                <img src={location} alt='na' className='icon' />
                <p>{carousel.location}</p>
              </div>
              <div className='card-specs'>
                <div>
                  <img src={bed} alt='na' className='icon' />
                  <p>{carousel.bed}</p>
                </div>                
                <div>
                  <img src={bath} alt='na' className='icon' />
                  <p>{carousel.bath}</p>
                </div>            
                <div>
                  <img src={square} alt='na' className='icon' />
                  <p>{carousel.size}</p>
                </div>         
              </div>
            </div>
          </div>
          ))}
        </Carousel>
      </div>  */